const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      // Core Web Vitals
      getCLS(onPerfEntry); // Cumulative Layout Shift
      getFID(onPerfEntry); // First Input Delay
      getFCP(onPerfEntry); // First Contentful Paint
      getLCP(onPerfEntry); // Largest Contentful Paint
      getTTFB(onPerfEntry); // Time to First Byte
      
      // Log performance metrics to console in development
      if (process.env.NODE_ENV === 'development') {
        getCLS(metric => {
          console.log('CLS:', metric.value);
        });
        getFID(metric => {
          console.log('FID:', metric.value);
        });
        getFCP(metric => {
          console.log('FCP:', metric.value);
        });
        getLCP(metric => {
          console.log('LCP:', metric.value);
        });
        getTTFB(metric => {
          console.log('TTFB:', metric.value);
        });
      }
    });
  }
};

export default reportWebVitals;
